import * as React from 'react';

export const TrashBin = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" {...props}>
        <g id="trashbin" fill="none" fillRule="evenodd" stroke="#FF3457" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2">
            <path d="M6.159 8.467v4.264M9.175 8.467v4.264M13.298 4.2v11.52c0 .707-.42 1.28-.938 1.28H2.97c-.518 0-.938-.573-.938-1.28V4.2M1 4.2h13.333M5.127 4.198V2.066c0-.588.38-1.066.846-1.066h3.385c.468 0 .847.478.847 1.066v2.132"/>
        </g>
    </svg>
);

export default TrashBin;



// WEBPACK FOOTER //
// ./src/Assets/images/svg/trashbin.tsx